<template>
  <!-- 日期选择器弹出层 -->
  <div>
    <van-dialog
      class="custom-dialog"
      v-model="dialogShow"
      :show-cancel-button="true"
      :before-close="beforeClose"
      confirm-button-text="确定"
      confirm-button-color="#3399FF"
      cancel-button-color="#646464"
    >
      <div class="dialog-content">
        <div class="title">修改预约时间</div>
        <div class="sub-tilte">预约时间</div>

        <div
          class="appointment-time-box"
          @click="editTime"
        >
          <span v-if="appointmentTime">{{ appointmentTime }}</span>
          <span
            class="time"
            v-else
          >选择时间</span>
          <img
            class="img"
            src="@/assets/img/order_icon_filter_nor.png"
          >
        </div>

        <template v-if="needReason">
          <div class="sub-tilte">预约原因</div>
          <van-field
            v-model="appointmentReason"
            rows="3"
            class="input-box"
            type="textarea"
            placeholder="字数3-100，不允许填写仅数字"
            show-word-limit
            maxlength="100"
          />
        </template>
      </div>
    </van-dialog>

    <!-- 日期选择器弹出层 -->
    <van-popup
      v-model="showDatePicker"
      round
      position="bottom"
    >
      <van-datetime-picker
        type="datetime"
        :min-date="dateRange.minDate"
        :max-date="dateRange.maxDate"
        :formatter="dateFormatter"
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { Toast } from 'vant';
import {
  updateAppointment
} from '@/common/apiGeneral.js';

export default {
  name: 'AppointmentTimeAlertView',
  props: {
    taskNo: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showDatePicker: false,
      appointmentReason: '',
      appointmentTime: '',
      dialogShow: false,
      needReason: true,
      customDateRange: null,
      customDateRangeGetter: null,
      dateRange: {
        minDate: new Date(),
        maxDate: new Date()
      }
    };
  },
  methods: {
    getDefaultDateRange() {
      // 只能选择今天起，7天内的日期（含今天）
      const now = dayjs();
      const minDate = now.add(1, 'minute');
      let maxDate = now.add(6, 'day');
      maxDate = maxDate.set('hour', 23);
      maxDate = maxDate.set('minute', 59);
      maxDate = maxDate.set('second', 59);
      maxDate = maxDate.subtract(1, 'minute');

      return {
        minDate: new Date(minDate),
        maxDate: new Date(maxDate)
      };
    },
    refreshDateRange() {
      if (this.customDateRangeGetter) {
        this.dateRange = this.customDateRangeGetter();
        return;
      }
      if (this.customDateRange) {
        this.dateRange = this.customDateRange;
        return;
      }
      this.dateRange = this.getDefaultDateRange();
    },
    open(res = {}) {
      const appointmentTime = res.appointmentTime || '';
      this.appointmentTime = appointmentTime.includes('实时') ? '' : appointmentTime;
      this.appointmentReason = res.appointmentReason || '';
      this.needReason = res.needReason !== false;
      this.customDateRange = res.dateRange || null;
      this.customDateRangeGetter = res.dateRangeGetter || null;
      this.refreshDateRange();
      this.dialogShow = true;
    },
    closeClick() {
      this.dialogShow = false;
      this.showDatePicker = false;
      this.appointmentReason = '';
      this.customDateRange = null;
      this.customDateRangeGetter = null;
      this.needReason = true;
      this.dateRange = this.getDefaultDateRange();
    },
    onDateConfirm(date) {
      this.showDatePicker = false;
      const res = dayjs(date).format('YYYY-MM-DD HH:mm');
      this.appointmentTime = res;
    },
    dateFormatter(type, val) {
      switch (type) {
        case 'year':
          return val + '年';
        case 'month':
          return val + '月';
        case 'day':
          return val + '日';
        case 'hour':
          return val + '点';
        case 'minute':
          return val + '分';
        default:
          return val;
      }
    },
    verifyClick() {
      if (!this.appointmentTime) {
        Toast('预约时间不能为空');
        return false;
      }
      if (!this.needReason) {
        return true;
      }
      if (!this.appointmentReason) {
        Toast('预约原因不能为空');
        return false;
      }
      if (this.appointmentReason.length < 3) {
        Toast('预约原因至少输入3个字符');
        return false;
      }
      const reg = /^[0-9]+$/;
      if (reg.test(this.appointmentReason)) {
        Toast('不允许填写仅数字');
        return false;
      }
      return true;
    },

    beforeClose: function(action, done) {
      // 点击事件 - 备注按钮提示框
      if (action === 'confirm') {
        if (this.verifyClick()) {
          this.updateAppointment();
          done(); // 关闭提示框
        } else {
          done(false); // 阻止关闭弹框
        }
      } else if (action === 'cancel') {
        this.closeClick();
        done(); // 关闭提示框
      }
    },

    async updateAppointment() {
      try {
        await updateAppointment({
          taskNo: this.taskNo,
          appointmentTime: this.appointmentTime,
          appointmentReason: this.needReason ? (this.appointmentReason || '') : ''
        });
        this.$toast('修改成功');
        this.closeClick();
        this.$emit('confirm');
      } catch (error) {
        console.log(error);
      }
    },

    onDateCancel() {
      this.showDatePicker = false;
    },
    editTime() {
      this.refreshDateRange();
      this.showDatePicker = true;
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-content {
  font-size: 16px;
  color: #646464;

  .title {
    font-size: 16px;
    color: #383838;
    text-align: center;
    font-weight: 400;
    height: 50px;
    line-height: 50px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0pt 0px rgba(230, 230, 230, 1);
    border-radius: 8px 8px 0px 0px;
  }

  .sub-tilte {
    margin-top: 24px;
    padding-left: 16px;
    &::before{
        content: '*';
        color: #F32222;
        font-size: 0.3rem;
        font-weight: 100;
      }
  }

  .appointment-time-box {
    position: relative;
    display: flex;
    align-items: center;
    margin-top: 8px;
    margin-left: 16px;
    margin-right: 16px;
    height: 48px;
    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
    padding-left: 16px;

    .time {
      font-size: 15px;
      color: #c8c8c8;
    }

    .img {
      position: absolute;
      width: 8px;
      height: 8px;
      right: 16px;
    }
  }

  .input-box {
    width: calc(100% - 32px);
    height: 120px;
    margin-top: 8px;
    margin-left: 16px;
    margin-bottom: 24px;
    background: #ffffff;
    border: 1px solid rgba(200, 200, 200, 1);
    border-radius: 8px;
  }
}
</style>
